export default __webpack_public_path__ + "static/media/profile-placeholder.2fe7ad44.png";